import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';

export const Tooltip = ({
    content,
    children,
    position = 'top',
    className = ''
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const { theme } = useTheme();
    const isDark = theme?.id === 'dark';

    const positionClasses = {
        top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 -translate-y-1/2 ml-2'
    };

    const arrowClasses = {
        top: 'top-full left-1/2 -translate-x-1/2 border-t-gray-800 dark:border-t-gray-700',
        bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-gray-800 dark:border-b-gray-700',
        left: 'left-full top-1/2 -translate-y-1/2 border-l-gray-800 dark:border-l-gray-700',
        right: 'right-full top-1/2 -translate-y-1/2 border-r-gray-800 dark:border-r-gray-700'
    };

    return (
        <div
            className={`relative inline-block ${className}`}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div className={`absolute z-50 ${positionClasses[position]} w-max max-w-xs animate-fadeIn`}>
                    <div className={`
            px-3 py-2 text-xs rounded shadow-lg
            ${isDark ? 'bg-gray-700 text-white border border-gray-600' : 'bg-gray-800 text-white'}
          `}>
                        {content}
                        {/* Arrow */}
                        <div className={`absolute w-0 h-0 border-4 border-transparent ${arrowClasses[position]}`}></div>
                    </div>
                </div>
            )}
        </div>
    );
};
